// extracted by mini-css-extract-plugin
module.exports = {"clients":"clients-module--clients--XpdTq","client":"clients-module--client--1ayVO"};